import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Departamento, Municipio, Distrito, DetallesCapis, ModificarCapis } from '../utils/utils';
import { useEffect, useState } from "react";
import Cookies from 'js-cookie';



function FormularioNuevoCapi() {
	const navigate = useNavigate();

	const { register, handleSubmit, formState: { errors }, setError, clearErrors, watch } = useForm({
		initialValues: {
			nombre_establecimiento: '',
			id_autorizacion: '',
			naturaleza: '',
			departamento: '',
			municipio: '',
			colonia: '',
			calle: '',
			edades: '',
			mensualidad: '',
			matricula: '',
			capacidad: '',
			telefono_fijo: '',
			telefono_movil: '',
			latitud: '',
			longitud: '',
			imagen: '',
		}
	})

	const { id_autorizacion } = useParams();
	const [departamento, setDepartamento] = useState([]);
	const [municipios, setMunicipios] = useState([]);
	const [distritos, setDistritos] = useState([]);
	const [preview, setPreview] = useState(null);
	const [capis, setCapis] = useState([]);

	async function getCapisList() {
		let capis = await ModificarCapis();
		console.log(capis);
		setCapis(capis);
	}

	async function getDepartamento() {
		setDepartamento(await Departamento());
	}

	async function handleMunicipio(element) {
		// console.log(element);
		if (element.target.value !== "") {
			// console.log("handle");
			let municipioData = await Municipio(element.target.value);
			console.log(municipioData);
			setMunicipios(municipioData);
			return;
		}

		setMunicipios([]);
		return;
	}

	useEffect(function () {
		getDepartamento();
		getCapisList();
	}, []);

	async function handleDistrito(element) {
		// console.log(element);
		if (element.target.value !== "") {
			// console.log("handle");
			let distritoData = await Distrito(element.target.value);
			console.log(distritoData);
			setDistritos(distritoData);
			return;
		}

		setDistritos([]);
		return;
	}

	const imagenSeleccionada = watch("imagen");

	const handleImageChange = (event) => {
		const file = event.target.files[0];
		if (file) {
			const imageUrl = URL.createObjectURL(file);
			setPreview(imageUrl);
		}
	};

	async function validar(e) {
		console.log(e);

		let session = Cookies.get("AuthToken");
		let uri = process.env.REACT_APP_API_URL + 'admin/capis';

		let config = {
			headers: {
				'Content-Type': 'multipart/form-data',
				'Accept': 'application/json',
				'Authorization': `Bearer ${session}`,
			}
		};

		console.log(e, 'e')

		try {
			let response = await axios({
				method: 'POST',
				url: uri,
				data: {
					...e,
					imagen: e.imagen[0]
				},
				headers: config.headers
			});
			console.log(response);
			Swal.fire(
				{
					title: 'Guardado',
					text: 'Datos almacenados exitosamente',
					icon: 'success',
					confirmButtonText: 'Aceptar'
				}
			)
				.then(function () {
					navigate("/Mantenimiento")
				}
				)
		} catch (error) {
			console.log(error);
			Swal.fire({
				title: "Error",
				text: "Error al subir los datos, intenta nuevamente",
				icon: "error"
			});
		}
	}

	const validarId = (value) => {
		const cleanedValue = value.replace(/[^0-9-]/g, "").replace(/\s/g, "");

		const soloNumeros = cleanedValue.replace(/-/g, "");
		if (soloNumeros.length > 8) return value;

		let formattedValue = "CAPI";
		if (soloNumeros.length > 0) formattedValue += "-" + soloNumeros.slice(0, 4);
		if (soloNumeros.length > 4) formattedValue += "-" + soloNumeros.slice(4, 8);

		// Validación de longitud (8 dígitos + 2 guiones)
		if (soloNumeros.length === 8) {
			clearErrors("id_autorizacion"); // Limpia el error si es válido
		} else {
			setError("id_autorizacion", {
				type: "manual",
				message: "El ID de autorización debe tener únicamente 8 numeros).",
			});
		}
		return formattedValue;
	}

	const validarTelefono = (value) => {
		const cleanedValue = value.replace(/[^0-9-]/g, "").replace(/\s/g, "");

		const soloNumeros = cleanedValue.replace(/-/g, "");
		if (soloNumeros.length > 8) return value;

		let formattedValue = "+503";
		if (soloNumeros.length > 0) formattedValue += " " + soloNumeros.slice(0, 4);
		if (soloNumeros.length > 4) formattedValue += "-" + soloNumeros.slice(4, 8);

		// Validación de longitud (8 dígitos + 2 guiones)
		if (soloNumeros.length === 8) {
			clearErrors("id_autorizacion"); // Limpia el error si es válido
		} else {
			setError("id_autorizacion", {
				type: "manual",
				message: "El ID de autorización debe tener únicamente 8 numeros).",
			});
		}
		return formattedValue;
	}

	return (
		<div className="mt-5 mx-6 w-auto mb-6 font-bold">
			<div className="flex flex-row w-auto items-start mb-4">
				<Link to="/VistaDatosCapis" className="flex justify-start">
					<button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white w-full rounded-full w-[50px] h-[50px] p-[12px]"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
				</Link>
				<div className="flex flex-col w-auto px-3 justify-between">
					<h1 className="text-4xl font-bold text-[#063E5F] text-start">Nuevo CAPI</h1>
					<p className="font-normal">Está destinada a la creación de un nuevo capi. Desde aquí, podrás ingresar la información necesaria para crear y guardar un nuevo capítulo según los requisitos establecidos</p>
				</div>
			</div>
			<form onSubmit={handleSubmit(validar)} className="flex flex-col mr-5 w-auto border-2 rounded-xl" id="formulario">
				<h1 className='bg-[#097493] text-white text-center text-xl p-2 font-semibold rounded-t-xl'>Ingresar datos del CAPI</h1>
				<div>
					<div className="flex flex-row p-2 h-auto">
						<div className="mr-2 w-1/2 h-2/3">
							<label for="nombre">Nombre del Establecimiento</label>
							<input id="" placeholder="Ingresar nombre del establecimiento" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.nombre_establecimiento ? 'border-red-600' : ''}`} type="text" {...register("nombre_establecimiento", { required: "El nombre del establecimiento es requerido" })} />
							{errors.nombre_establecimiento && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.nombre_establecimiento.message}</span>}
						</div>
						<div className="mx-2 w-1/3 h-2/3">
							<label for="nombre">Número de autorización</label>
							<input type="tel" placeholder="CAPI-0000-0000" inputMode='numeric' maxLength='14' name='id_autorizacion' id='id_autorizacion' className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg outline-none ${errors.id_autorizacion ? 'border-red-600' : ''}`} {...register("id_autorizacion", { required: "Ingresa el número de Autorización del CAPI" })} onChange={(event) => {
								const { value } = event.target
								event.target.value = validarId(value)
							}} />
							{errors.id_autorizacion && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.id_autorizacion.message}</span>}
						</div>
						<div className="mx-2 w-1/3">
							<label for="nombre">Tipo de Privacidad</label>
							<select className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.naturaleza ? 'border-red-600' : ''}`} {...register("naturaleza", { required: "Selecciona la privacidad del CAPI" })}>
								<option value="">Privacidad</option>
								<option value="Patronal">Patronal</option>
								<option value="Privado">Privado</option>
								<option value="Publico">Público</option>
							</select>
							{errors.naturaleza && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.naturaleza.message}</span>}
						</div>
					</div>
					<div className="flex flex-row p-2">
						<div className="mr-2 w-1/3">
							<label className="p-1">Departamento</label>
							<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg outline-none ${errors.departamento ? 'border-red-600' : ''}`} {...register("departamento", { required: "Selecciona el departamento donde se ubica el CAPI" })}
								onChange={handleMunicipio}
							>
								<option value="">Seleccione su departamento</option>
								{departamento.map(function (item, index) {
									return (
										<option key={index} value={item.id}>{item.name}</option>
									);
								})}
							</select>
							{errors.departamento && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.departamento.message}</span>}
						</div>
						<div className="mx-2 w-1/3">
							<label className="p-1">Municipio</label>
							<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg outline-none ${errors.municipio ? 'border-red-600' : ''}`} {...register("municipio", { required: "Selecciona el municipio donde se ubica el CAPI" })}
								onChange={handleDistrito}
							>
								<option value="">Seleccione su municipio</option>
								{municipios.map(function (item, index) {
									return (
										<option key={index} value={item.id}>{item.name}</option>
									);
								})}
							</select>
							{errors.municipio && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.municipio.message}</span>}
						</div>
						<div className="mx-4 w-1/3">
							<label className="p-1">Distrito</label>
							<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg outline-none ${errors.distrito ? 'border-red-600' : ''}`} {...register("distrito", { required: "Selecciona el distrito donde se ubica el CAPI" })}>
								<option value="">Seleccione su distrito</option>
								{distritos.map(function (item, index) {
									return (
										<option key={index} value={item.id}>{item.name}</option>
									);
								})}
							</select>
							{errors.distrito && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.distrito.message}</span>}
						</div>
					</div>
					<div className="flex flex-row p-2">
						<div className="mr-2 w-1/2">
							<label for="nombre">Nombre de Colonia</label>
							<input id="" placeholder="Ingresar nombre de Colonia" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.colonia ? 'border-red-600' : ''}`} type="text" {...register("colonia", { required: "Ingresa el nombre de la colonia donde se encuentra el CAPI" })} />
							{errors.colonia && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.colonia.message}</span>}
						</div>
						<div className="mx-2 w-1/2">
							<label for="nombre">Nombre de calle</label>
							<input id="" placeholder="Ingresar nombre de Calle" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.calle ? 'border-red-600' : ''}`} type="text" {...register("calle", { required: "Ingresa el nombre de la calle donde se encuentra el CAPI" })} />
							{errors.calle && <span className='text-red-600'>{errors.calle.message}</span>}
						</div>
					</div>
					<div className="flex flex-row p-2 items-center">
						<div className="mr-2 w-1/4 h-full">
							<label for="nombre">Edades</label>
							<div className={`py-2 w-full items-center grid grid-cols-4 justify-between text-sm font-normal bg-[#D1ECF2] rounded-lg border-2 ${errors.edades ? 'border-red-600' : ''}`}>
								<input type="checkbox" value="0-12 Meses" {...register("edades", { validate: value => value?.length > 0 || "Debes seleccionar al menos una opción" })} />0-12 meses
								<input type="checkbox" value="12-24 Meses" {...register("edades", { validate: value => value?.length > 0 || "Debes seleccionar al menos una opción" })} />12-24 meses
								<input type="checkbox" value="24-36 Meses" {...register("edades", { validate: value => value?.length > 0 || "Debes seleccionar al menos una opción" })} />24-36 meses
								<input type="checkbox" value="36-48 Meses" {...register("edades", { validate: value => value?.length > 0 || "Debes seleccionar al menos una opción" })} />36-48 meses
							</div>
							{errors.edades && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.edades.message}</span>}

						</div>
						<div className="mx-2 w-1/4 h-2/3">
							<label for="nombre" >Mensualidad</label>
							<input id="" placeholder="Costo de mensualidad" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.mensualidad ? 'border-red-600' : ''}`} type="number" {...register("mensualidad")} />
							{errors.mensualidad && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.mensualidad.message}</span>}

						</div>
						<div className="mx-2 w-1/4 h-2/3">
							<label for="nombre">Matrícula</label>
							<input id="" placeholder="Costo de Matrícula" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.matricula ? 'border-red-600' : ''}`} type="number" {...register("matricula")} />
							{errors.matricula && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.matricula.message}</span>}
						</div>
						<div className="mx-2 w-1/4 h-2/3">
							<label for="nombre">Capacidad Máxima</label>
							<input id="" placeholder="Capacidad" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.capacidad ? 'border-red-600' : ''}`} type="number" {...register("capacidad")} />
							{errors.capacidad && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.capacidad.message}</span>}
						</div>
					</div>
					<div className="flex flex-row p-2">
						<div className="mr-2 w-1/2">
							<label for="nombre">Latitud</label>
							<input id="" placeholder="00.0000" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.latitud ? 'border-red-600' : ''}`} type="number" step="0.000000000000001" {...register("latitud", { 
								required: "Ingresa la latitud de la ubicación geográfica del CAPI (brindada por Google Maps)",
								pattern: {
									value: /^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}/,
									message: "Ingresa una latitud válida"
								}
							})} />
							{errors.latitud && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.latitud.message}</span>}

						</div>
						<div className="mx-2 w-1/2">
							<label for="nombre">Longitud</label>
							<input id="" placeholder="-00.0000" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.longitud ? 'border-red-600' : ''}`} type="number" step="0.000000000000001" {...register("longitud", { 
								required: "Ingresa la longitud de la ubicación geográfica del CAPI (brindada por Google Maps)",
								pattern: {
									value: /^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}/,
									message: "Ingresa una longitud válida"
								}
							})} />
							{errors.longitud && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.longitud.message}</span>}
						</div>
					</div>
					<div className="flex flex-row p-2 h-auto">
						<div className="mr-2 w-1/3">
							<label for="nombre">Número de teléfono fijo</label>
							<input id="" placeholder="+503 0000-0000" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.telefono_fijo ? 'border-red-600' : ''}`} type="tel" {...register("telefono_fijo", { required: "Ingresa el número fijo del CAPI" })} />
							{errors.telefono_fijo && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.telefono_fijo.message}</span>}

						</div>
						<div className="mx-2 w-1/3">
							<label for="nombre">Número de telefono celular</label>
							<input id="" placeholder="+503 0000-0000" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.telefono_movil ? 'border-red-600' : ''}`} type="text" {...register("telefono_movil", { required: "Ingresa el número celular del CAPI" })} />
							{errors.telefono_movil && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.telefono_movil.message}</span>}
						</div>
						<div className="mx-2 w-1/3 h-2/3">
							<label>Subir imagen de logo</label>
							<input id="" className="w-full border-2 p-4 bg-[#D1ECF2] rounded-lg font-normal" type="file" accept='image/*' {...register("imagen")} />
							{errors.imagen && <span className='text-red-600'>{errors.imagen.message}</span>}
							{/* {preview && (
                <div className="mt-4">
                    <p className="text-gray-700">Vista previa:</p>
                    <img src={preview} alt="Vista previa" className="w-40 h-40 object-cover rounded-lg border" onChange={handleImageChange} />
                </div>
            )} */}
						</div>
					</div>
					<div className="flex justify-end">
						<div className='w-[260px] justify-between flex flex-row'>
							<Link to="/VistaDatosCapis" data-discover="true">
								<button className="bg-[#9E130D] font-medium drop-shadow-2xl shadow-2xl text-white rounded-full w-[125px] h-[50px] p-[12px]">Cancelar</button>
							</Link>
							<button type="submit" className="bg-[#99C33E] font-medium drop-shadow-2xl shadow-2xl text-white rounded-full w-[125px] h-[50px] p-[12px]">Agregar</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	)
}

export default FormularioNuevoCapi;